<template>
  <AuthPage
    context="organization"
    :title="title"
    :loading="loading"
    :show-federated-login="false"
    form-button="Find organization"
    show-form
    @submit="submit"
  >
    <template #form>
      <AuthFormInput
        id="email"
        v-model="emailAddress"
        label="Work email address"
        type="email"
        placeholder="you@company.com"
        required
        autocomplete="username"
        data-id="organization-email"
      >
        <template #label>
          <span class="mr-1"> Know your team name? </span>
          <AuthLink
            tag="button"
            type="button"
            data-id="organization-slug-enter"
            title="Enter slug"
            @click="handleId"
          />
        </template>
      </AuthFormInput>
    </template>
    <template #notes>
      <AuthNotesCard>
        Do you use internal SSO?
        <AuthLink
          tag="a"
          title="Open SAML login"
          to="https://enterprise.mailslurp.com"
          data-id="auth-link-signup"
        />
      </AuthNotesCard>
    </template>
  </AuthPage>
</template>
<script setup lang="ts">
import { onMounted, ref } from 'vue';

import { useStore3 } from '../../store/main';
import { Variant } from '../../store/types';
import AuthPage from '../../components/auth/AuthPage.vue';
import AuthLink from '../../components/auth/AuthLink.vue';
import AuthNotesCard from '../../components/auth/AuthNotesCard.vue';
import AuthFormInput from '../../components/auth/AuthFormInput.vue';
import { useRoute, navigateTo, computed } from '#imports';
const store3 = useStore3();
const route = useRoute();

const handleId = () => {
  const id = window.prompt('Enter your organization ID');
  if (id) {
    navigateTo('/organization/' + id);
  }
};
const loading = ref<boolean>(false);
const emailAddress = ref<string>('');
const mode = ref<string>('login');
const done = ref<boolean>(false);
const doneMessage = ref<string>('');

const title = computed(() => {
  return mode.value === 'login' ? 'Organization finder' : 'Verifying';
});

onMounted(async () => {
  const { code, state } = route.query;
  if (code && state) {
    mode.value = 'callback';
    done.value = false;
    loading.value = true;
    try {
      await store3.verifyOrganizationAccess({
        organizationSlug: state as string,
        challengeCode: code as string,
      });
      loading.value = false;
      await navigateTo('/inboxes');
    } catch (e) {
      loading.value = false;
      store3.setError({
        error: e,
      });
      mode.value = 'login';
    }
  }
});

const submit = async () => {
  try {
    loading.value = true;
    await store3.remindOrganizations(emailAddress.value);
    done.value = true;
    doneMessage.value =
      'Please check your email for a list of organization links.';
    loading.value = false;
  } catch (e: unknown) {
    loading.value = false;
    if (e && (e as { status: number }).status === 404) {
      store3.setFlash({
        variant: Variant.warning,
        text: 'No organization found for user. You must be invited to an organization. If you own an organization use the normal login method.',
      });
    } else {
      store3.setError({
        error: e,
      });
    }
  }
};
</script>
